export default {
  MuiDivider: {
    styleOverrides: {
      root: {
        borderColor: '#f0f0f0'
      }
    }
  }
};
